// extracted by mini-css-extract-plugin
module.exports = {"score":"memberStatistics_score__m85ap","scoreLabel":"memberStatistics_scoreLabel__CFVHM","stat":"memberStatistics_stat__3TLHq"};